/*=========================================================================================
  File Name: moduleTransactionManagement.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/Transaction/pixinvent
==========================================================================================*/


import state from './moduleTransactionManagementState.js'
import mutations from './moduleTransactionManagementMutations.js'
import actions from './moduleTransactionManagementActions.js'
import getters from './moduleTransactionManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

